/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section3_Li2Inputs */

const en_about_section3_li2 = /** @type {(inputs: About_Section3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Formatter & Beautifier: Format and indent JSON with customizable spacing options`)
};

const ko_about_section3_li2 = /** @type {(inputs: About_Section3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 포맷터 & 정리기: 사용자 정의 가능한 간격 옵션으로 JSON 포맷 및 들여쓰기`)
};

const ja_about_section3_li2 = /** @type {(inputs: About_Section3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONフォーマッター＆整形ツール: カスタマイズ可能なスペースオプションでJSONをフォーマット・インデント`)
};

/**
* | output |
* | --- |
* | "JSON Formatter & Beautifier: Format and indent JSON with customizable spacing options" |
*
* @param {About_Section3_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section3_li2 = /** @type {((inputs?: About_Section3_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section3_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section3_li2(inputs)
	if (locale === "ko") return ko_about_section3_li2(inputs)
	return ja_about_section3_li2(inputs)
});